module.exports = __webpack_public_path__ + "fonts/icon_set_1.e4bdda9c.woff";